import { createSelector } from 'reselect';

export const Types = {
  GET_REQUEST: 'benefitsTypes/GET_REQUEST',
  GET_SUCCESS: 'benefitsTypes/GET_SUCCESS',
  GET_FAILURE: 'benefitsTypes/GET_FAILURE',

  GET_LIST_REQUEST: 'benefitsTypes/GET_LIST_REQUEST',
  GET_LIST_SUCCESS: 'benefitsTypes/GET_LIST_SUCCESS',
  GET_LIST_FAILURE: 'benefitsTypes/GET_LIST_FAILURE',

  GET_PLANS_REQUEST: 'benefitsTypes/GET_PLANS_REQUEST',
  GET_PLANS_SUCCESS: 'benefitsTypes/GET_PLANS_SUCCESS',
  GET_PLANS_FAILURE: 'benefitsTypes/GET_PLANS_FAILURE',

  CREATE_REQUEST: 'benefitsTypes/CREATE_REQUEST',
  CREATE_SUCCESS: 'benefitsTypes/CREATE_SUCCESS',
  CREATE_FAILURE: 'benefitsTypes/CREATE_FAILURE',

  UPDATE_REQUEST: 'benefitsTypes/UPDATE_REQUEST',
  UPDATE_SUCCESS: 'benefitsTypes/UPDATE_SUCCESS',
  UPDATE_FAILURE: 'benefitsTypes/UPDATE_FAILURE',

  DELETE_REQUEST: 'benefitsTypes/DELETE_REQUEST',
  DELETE_SUCCESS: 'benefitsTypes/DELETE_SUCCESS',
  DELETE_FAILURE: 'benefitsTypes/DELETE_FAILURE',
};

const initialState = {
  data: [],
  loading: true,
  page: 1,
  totals: 1,

  detail: {
    data: {},
    loading: true,
  },

  plans: {
    data: [],
    loading: false,
  },

  create: {
    loading: false,
  },

  update: {
    loading: false,
  },

  delete: {
    loading: false,
  },
};

export default function benefitsTypes(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REQUEST:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: true,
        },
      };
    case Types.GET_SUCCESS:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
          data: action.payload.benefitType.data,
        },
      };
    case Types.GET_FAILURE:
      return {
        ...state,
        detail: {
          ...state.detail,
          loading: false,
        },
      };
    case Types.GET_LIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.GET_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.benefitsTypes.data,
        page: action.payload.benefitsTypes.meta.current_page,
        totals: action.payload.benefitsTypes.meta.total_pages,
      };
    case Types.GET_LIST_FAILURE:
      return {
        ...state,
        loading: false,
      };
    case Types.GET_PLANS_REQUEST:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: true,
        },
      };
    case Types.GET_PLANS_SUCCESS:
      return {
        ...state,
        plans: {
          ...state.plans,
          data: action.payload.plans.data,
          loading: false,
        },
      };
    case Types.GET_PLANS_FAILURE:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: false,
        },
      };
    case Types.CREATE_REQUEST:
      return {
        ...state,
        create: {
          ...state.create,
          loading: true,
        },
      };
    case Types.CREATE_SUCCESS:
    case Types.CREATE_FAILURE:
      return {
        ...state,
        create: {
          ...state.create,
          loading: false,
        },
      };
    case Types.UPDATE_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          loading: true,
        },
      };
    case Types.UPDATE_SUCCESS:
    case Types.UPDATE_FAILURE:
      return {
        ...state,
        update: {
          ...state.update,
          loading: false,
        },
      };
    default:
      return state;
  }
}

export const Creators = {
  getBenefitTypeRequest: id => ({
    type: Types.GET_REQUEST,
    payload: { id },
  }),

  getBenefitTypeSuccess: benefitType => ({
    type: Types.GET_SUCCESS,
    payload: { benefitType },
  }),

  getBenefitTypeFailure: () => ({
    type: Types.GET_FAILURE,
  }),

  getBenefitsTypesRequest: (page = 1, filters = null) => ({
    type: Types.GET_LIST_REQUEST,
    payload: { page, filters },
  }),

  getBenefitsTypesSuccess: benefitsTypes => ({
    type: Types.GET_LIST_SUCCESS,
    payload: { benefitsTypes },
  }),

  getBenefitsTypesFailure: () => ({
    type: Types.GET_LIST_FAILURE,
  }),

  getBenefitsTypesPlansRequest: () => ({
    type: Types.GET_PLANS_REQUEST,
  }),

  getBenefitsTypesPlansSuccess: plans => ({
    type: Types.GET_PLANS_SUCCESS,
    payload: { plans },
  }),

  getBenefitsTypesPlansFailure: () => ({
    type: Types.GET_PLANS_FAILURE,
  }),

  createBenefitsTypesRequest: data => ({
    type: Types.CREATE_REQUEST,
    payload: { data },
  }),

  createBenefitsTypesSuccess: () => ({
    type: Types.CREATE_SUCCESS,
  }),

  createBenefitsTypesFailure: () => ({
    type: Types.CREATE_FAILURE,
  }),

  updateBenefitsTypesRequest: (id, data) => ({
    type: Types.UPDATE_REQUEST,
    payload: { id, data },
  }),

  updateBenefitsTypesSuccess: () => ({
    type: Types.UPDATE_SUCCESS,
  }),

  updateBenefitsTypesFailure: () => ({
    type: Types.UPDATE_FAILURE,
  }),

  deleteBenefitsTypesRequest: id => ({
    type: Types.DELETE_REQUEST,
    payload: { id },
  }),

  deleteBenefitsTypesSuccess: () => ({
    type: Types.DELETE_SUCCESS,
  }),

  deleteBenefitsTypesFailure: () => ({
    type: Types.DELETE_FAILURE,
  }),
};

export const Selectors = {
  benefitsTypes: createSelector(
    state => state,
    benefitsTypes =>
      benefitsTypes.map(benefitType => ({
        ...benefitType,
        attributes: {
          ...benefitType.attributes,
        },
      })),
  ),

  plans: createSelector(
    state => state,
    plans => plans.map(plan => ({ value: plan.id, label: plan.attributes.name })),
  ),
  plans_code: createSelector(
    state => state,
    plans => plans.map(plan => ({ value: plan.attributes.code, label: plan.attributes.name })),
  ),
};
